import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import Table from 'components/atoms/Table'
import NullComponent from 'components/molecules/NullComponent'
import AdminHeader from 'components/molecules/admin/AdminHeader'
import AddCompanyModal from 'components/organisms/admin/companies/AddCompanyModal'
import FilterCompaniesModal from 'components/organisms/admin/companies/FilterCompaniesModal'
import { showErrorMessage, showSuccessMessage } from 'utils/showMessage'
import AdminPagination from 'components/atoms/AdminPagination'
import { useSelector } from 'react-redux'
import { getCompanyList } from 'api'
import moment from 'moment'
import { Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAuth } from 'hooks'
import { formatDate } from 'lib/utils'
import { SUBSCRIPTION_STATUS } from 'constant'
const initialTableState = {
  total: 0,
  page: 1,
  limit: 9,
  search: '',
  sort: '-created_at'
}

const initialFilterState = {
  typeCountUsers: undefined,
  startUserNumbers: undefined,
  endUserNumbers: undefined,
  typeDate: undefined,
  startDate: undefined,
  endDate: undefined,
  filter_subscription_type: '',
  filter_subscription_status: ''
}

const CompaniesPage = () => {
  const { state } = useLocation()
  const [filter, setFilter] = useState({ show: false })
  const [filterState, setFilterState] = useState(initialFilterState)
  const [filterCount, setFilterCount] = useState(0)
  const [addModal, setAddModal] = useState(state?.addNew ? state?.addNew : false)
  const [tableState, setTableState] = useState(initialTableState)
  const token = useSelector((state) => state.admin.access_token)

  const { onLogout } = useAuth()
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  // RESET STATE ADD NEW WITHOUT TRIGGER RE-RENDER
  state ? window.history.replaceState({}, '') : null

  const { isLoading, data, refetch } = useQuery({
    queryKey: [
      'admin-companies-list',
      tableState?.sort,
      tableState?.limit,
      tableState?.page,
      tableState?.search,
      filterState
    ],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await getCompanyList(token, filterState, tableState)
      return res
    },
    onSuccess: (res) => {
      setTableState({
        ...tableState,
        total: res?.resData?.meta?.total
      })
    },
    onError: (err) => {
      //console.log('err', err);
      showErrorMessage(t('error messages.Internal server error'))
      if (err?.response?.status === 403) {
        onLogout()
      }
    }
  })

  function openAddModal() {
    setAddModal(true)
  }
  function closeAddModal() {
    setAddModal(false)
  }

  function handleAddCompany() {
    refetch()
    showSuccessMessage(t('success messages.Company added'))
  }

  function closeFilterModal() {
    setFilter((prev) => ({ ...prev, show: false }))
  }
  function openFilterModal() {
    setFilter((prev) => ({ ...prev, show: true }))
  }

  function handleSearch(value) {
    setTableState((prevState) => ({
      ...prevState,
      search: value
    }))
  }

  const handleSort = (column, sortDirection) => {
    setTableState((prevState) => ({
      ...prevState,
      sort: `${sortDirection === 'desc' ? '-' : ''}${column?.id}`,
      sort_order: sortDirection
    }))
  }

  function onChangePagination(_, page) {
    setTableState((prevState) => ({
      ...prevState,
      page: page
    }))
  }

  function handleSubmitFilter(data) {
    const countDefined = Object.values(data).filter((value) => {
      return value !== undefined && value != null && value != ''
    }).length
    setFilterCount(countDefined || 0)
    setFilterState(data)
  }
  function resetFilter() {
    setFilterCount(0)
    setFilterState(initialFilterState)
  }








  const columns = [
    {
      id: 'name',
      name: t('COMPANY NAME'),
      selector: (row) => row?.name,
      sortable: true,
      cell: (row) => (
        <div>
          <Tooltip title={`${row?.name}`} className="flex">
            <div>
              <span className="line-clamp-1">
                {row?.name} {row?.surname}

              </span>
              


            </div>
          </Tooltip>
        </div>
      )
    },
    {
      id: 'is_active_flag',
      name: `STATUS ${t('Company').toUpperCase()}`,
      selector: (row) => moment(row?.created_at).format('DD/MM/YYYY'),
      sortable: false,
      cell: (row) => (
        <div>
          <Tooltip title={`${row?.name}`}>
            <div>
              <span className="line-clamp-1">


              </span>
              {(row?.subscription?.status === SUBSCRIPTION_STATUS.TRIAL || row?.subscription?.status === SUBSCRIPTION_STATUS.EXPIRED) && (
                <span className="active-flag mb-1">STAND BY</span>
              )}
              {!row.is_active_flag ? <span className="active-flag">{t('REMOVED')}</span> :
                <span className="active-flag">{t('Plans.Active')}</span>
              }


            </div>
          </Tooltip>
        </div>
      )
    },
    {
      id: 'last_payment_date',
      name: `${t('Pay.LastPayment').toUpperCase()}`,
      selector: (row) => moment(row?.last_payment_date).format('DD/MM/YYYY'),
      sortable: false,
      cell: (row) => (

        <p >
          {row?.last_payment_date ? formatDate(row?.last_payment_date) : '-'}
        </p>


      )
    },
    {
      id: 'payment_type',
      name: t('Plans.Subscription').toUpperCase(),
      selector: (row) => row?.subscription?.payment_type,
      sortable: false,
      cell: (row) => (
        <div>
          {row?.subscription.id > 0 ? t(`Plans.${row?.subscription?.payment_type}`) : t('Plans.NoSubscription')}
        </div>
      )
    },
    {
      id: 'status',
      name: `STATUS ${t('Plans.Subscription').toUpperCase()}`,
      selector: (row) => row?.subscription?.status,
      sortable: false,
      cell: (row) => (

        <p className={`${row?.subscription?.status === SUBSCRIPTION_STATUS.TRIAL || row?.subscription?.status === SUBSCRIPTION_STATUS.EXPIRED || row?.subscription?.status === SUBSCRIPTION_STATUS.NOT_PAYED || row?.subscription?.status === SUBSCRIPTION_STATUS.CANCELED ? 'text-[#E53E3E]' : 'text-white'}`}>
          
          {row?.subscription.id > 0 ? (
            <>
              {row?.subscription?.status === SUBSCRIPTION_STATUS.TRIAL ? SUBSCRIPTION_STATUS.TRIAL :
                row?.subscription?.status === SUBSCRIPTION_STATUS.NOT_PAYED ? t('Pay.Unpaid') :
                  row?.subscription?.status === SUBSCRIPTION_STATUS.EXPIRED ? `${t('Pay.Expired')}` :
                    row?.subscription?.status === SUBSCRIPTION_STATUS.CANCELED ? t('Plans.Deleted') :
                      row?.subscription?.status === SUBSCRIPTION_STATUS.ACTIVE && row?.subscription?.next_payment_date ? t('Plans.Active')
                        : t('Plans.ActivePaymentExternal')
              }
            </>
          ) : t('Plans.NoSubscription')}
          

        </p>


      )
    },
    {
      id: 'user_count',
      name: t('NO. USERS'),
      selector: (row) => row?.user_count,
      sortable: true,
      cell: (row) => (
        <div>
          {`${row?.user_count}/${row?.subscription?.seat_number}`}
        </div>
      )
    },
    {
      id: 'created_at',
      name: t('Creation Date').toUpperCase(),
      selector: (row) => moment(row?.created_at).format('DD/MM/YYYY'),
      sortable: true
    },

  ]

  function handleNavCompanyDetails(row) {
    navigate('/admin/companies/detail', {
      state: {
        ...row
      }
    })
  }




  return (
    <div className="flex flex-col gap-6 w-full overflow-y-auto pr-6">
      <AdminHeader
        onAdd={openAddModal}
        openFilter={openFilterModal}
        onSearch={handleSearch}
        title={t('Companies')}
        filterCount={filterCount}
      />
      <div className="flex flex-col h-full justify-between pb-4">
        {((isLoading && !data) || (data?.resData?.data?.length > 0 && !isLoading)) && (
          <>
            <Table
              pointerOnHover={true}
              highlightOnHover={true}
              defaultSortFieldId={'created_at'}
              defaultSortAsc={false}
              pending={isLoading}
              sortServer
              onChangePrevPage={() => {
                if (tableState?.page > 1)
                  setTableState((prevState) => {
                    return {
                      ...prevState,
                      page: prevState?.page - 1
                    }
                  })
              }}
              onChangeNextPage={() => {
                if ((tableState?.page + 1) * tableState?.limit <= data?.resData?.meta?.total)
                  setTableState((prevState) => {
                    return {
                      ...prevState,
                      page: prevState?.page + 1
                    }
                  })
              }}
              hidePagination
              data={data?.resData?.data}
              columns={columns}
              onRowClicked={handleNavCompanyDetails}
              currentPage={tableState?.page}
              totalPerPage={tableState?.limit}
              page={tableState?.page}
              pageSize={tableState?.limit}
              totalRows={data?.resData?.meta?.total}
              onSort={handleSort}
            />
            {data && (
              <div className="flex w-full justify-end items-center">
                <AdminPagination
                  count={Math.ceil(data?.resData?.meta?.total / tableState?.limit)}
                  page={tableState?.page}
                  onChange={onChangePagination}
                  shape="rounded"
                />
              </div>
            )}
          </>
        )}
        {data?.resData?.data?.length < 1 && !isLoading && (
          <NullComponent
            title={t('No company added')}
            description={t('Add a company and pair users to it')}
          />
        )}
        <FilterCompaniesModal
          show={filter.show}
          onClose={closeFilterModal}
          onSubmit={handleSubmitFilter}
          resetFilter={resetFilter}
          filterState={filterState}
        />
        <AddCompanyModal onClose={closeAddModal} show={addModal} onSubmit={handleAddCompany} />
      </div>
    </div>
  )
}

export default CompaniesPage
